import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@eduzz/houston-icons/SearchOutline';
import { useDispatch } from 'react-redux';
import { toggleInputFadeAnimation } from 'redux/globalSearch/slice';
import { useAppSelector } from 'hooks/redux';

const Search = () => {
  const searchIsDisabled = useAppSelector((store) => store.globalSearch.headerInput.disabled);
  const dispatch = useDispatch();
  const openSearchField = () => {
    dispatch(toggleInputFadeAnimation());
  };
  if (searchIsDisabled) {
    return null;
  }
  return (
    <IconButton id='header-search-icon-button' onClick={openSearchField}>
      <SearchIcon size={24} />
    </IconButton>
  );
};

export default Search;
